import { render, staticRenderFns } from "./DocPublicacoesListagem.vue?vue&type=template&id=b1a95b4c&scoped=true&lang=pug&"
import script from "./DocPublicacoesListagem.vue?vue&type=script&lang=js&"
export * from "./DocPublicacoesListagem.vue?vue&type=script&lang=js&"
import style0 from "./DocPublicacoesListagem.vue?vue&type=style&index=0&id=b1a95b4c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a95b4c",
  null
  
)

export default component.exports